import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from '../../service/auth.service';

@Component({
  selector: 'app-login',
  templateUrl:
    'console/app-js/modules/security/component/login/login.component.html',
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {
  constructor(
    private router: Router,
    private authService: AuthService,
    private msalService: MsalService
  ) {
    // Silence is golden.
  }

  // if the user has logged out manually, do not show unsupported browser message
  private manualLogout = JSON.parse(this.authService.getLogoutLocalStorage());
  public unsupportedBrowser = false;

  ngOnInit() {
    //var checkIfUserAuthentincated = !!this.msalService.getAccount();
    let isAuthenticated = this.authService.isAuthenticated();
    if (isAuthenticated) {
      this.authService.handleAuth();
      this.router.navigate([this.authService.getUserHomePage()]);
    } else {
      const isChromeOrSafari =
        window.navigator.userAgent.indexOf('Chrome') > -1 ||
        window.navigator.userAgent.indexOf('Safari') > -1
          ? true
          : false;
      const isIEOrEdge = /msie\s|trident\/|edge\//i.test(
        window.navigator.userAgent
      );
      const isOpera =
        window.navigator.userAgent.indexOf('OPR') > -1 ||
        window.navigator.userAgent.indexOf('Opera') > -1
          ? true
          : false;
      if ((!isChromeOrSafari || isIEOrEdge || isOpera) && !this.manualLogout) {
        this.unsupportedBrowser = true;
      } else {
        this.authService.removeLogoutLocalStorage();
        this.authService.login();
      }
    }
  }

  public closeBrowserModal(): void {
    this.unsupportedBrowser = false;
    this.authService.login();
  }
}
